var _circle, _circle2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1219_139)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 48,
    r: 15,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1219_139)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5988 23.2244C47.9531 23.6166 47.8596 23.9502 47.8596 25.8605C47.8596 27.1733 47.9016 27.6489 48.0413 27.9181C48.5971 28.9893 50.4079 28.9893 50.9637 27.9181C51.1035 27.6489 51.1455 27.1733 51.1455 25.8605C51.1455 23.9502 51.052 23.6166 50.4063 23.2244C49.9142 22.9252 49.0909 22.9252 48.5988 23.2244ZM30.5396 30.6463C29.8256 30.9561 29.4352 31.7824 29.6139 32.6054C29.7255 33.1195 31.8808 35.3293 32.4546 35.5181C33.6809 35.9213 34.9324 34.7218 34.5866 33.4743C34.4999 33.1613 34.1549 32.7067 33.4449 31.9701C32.101 30.5761 31.4184 30.265 30.5396 30.6463ZM66.9885 30.7085C66.7626 30.8284 66.121 31.3928 65.5628 31.9627C64.8178 32.7231 64.514 33.1237 64.4209 33.4683C64.0799 34.7304 65.3189 35.9231 66.5504 35.5181C67.1243 35.3293 69.2795 33.1195 69.3911 32.6054C69.7092 31.141 68.2878 30.0189 66.9885 30.7085ZM47.0967 35.3216C41.3704 36.2654 36.6101 40.2874 34.7919 45.7179C34.2316 47.3912 34.0727 48.4927 34.0799 50.6544C34.0855 52.3686 34.1285 52.8219 34.3914 53.9437C35.1309 57.0996 36.9062 60.0982 39.1808 62.0337C41.371 63.8972 41.9918 64.7449 42.175 66.1217L42.2568 66.7354H49.5177H56.7786L56.7825 66.3553C56.788 65.8012 57.1542 64.8311 57.6117 64.1586C57.8313 63.8359 58.5476 63.1295 59.2036 62.589C65.5388 57.3685 66.8246 48.6393 62.2619 41.8255C61.5205 40.7181 59.3333 38.5481 58.2135 37.8086C56.5528 36.7118 54.5851 35.8799 52.6125 35.4402C51.4874 35.1894 48.3127 35.1211 47.0967 35.3216ZM22.8668 48.9296C22.0673 49.3315 21.732 50.595 22.2436 51.278C22.7878 52.0044 22.9657 52.0579 24.8371 52.0579C26.7677 52.0579 27.1349 51.951 27.5688 51.2627C27.8652 50.7924 27.8258 49.8507 27.4905 49.3929C27.0766 48.828 26.676 48.7247 24.8988 48.725C23.5851 48.7251 23.1956 48.7642 22.8668 48.9296ZM72.2108 48.8369C72.0818 48.8904 71.8222 49.0965 71.6339 49.2947C71.1764 49.7767 71.0833 50.7029 71.4363 51.2627C71.8702 51.951 72.2374 52.0579 74.168 52.0579C76.0449 52.0579 76.2163 52.0057 76.7707 51.2656C77.0751 50.8593 77.0766 50.0514 76.774 49.5291C76.3797 48.8488 75.9594 48.7241 74.0885 48.7323C73.1849 48.7363 72.3399 48.7833 72.2108 48.8369ZM42.2834 70.2732C42.548 72.6912 43.6316 74.5531 45.4908 75.785C48.3833 77.7012 52.1544 77.3196 54.6216 74.8608C55.8557 73.6309 56.5049 72.2001 56.7295 70.2148L56.8056 69.5423H49.5045H42.2035L42.2834 70.2732Z",
    fill: "url(#paint1_linear_1219_139)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5988 23.2244C47.9531 23.6166 47.8596 23.9502 47.8596 25.8605C47.8596 27.1733 47.9016 27.6489 48.0413 27.9181C48.5971 28.9893 50.4079 28.9893 50.9637 27.9181C51.1035 27.6489 51.1455 27.1733 51.1455 25.8605C51.1455 23.9502 51.052 23.6166 50.4063 23.2244C49.9142 22.9252 49.0909 22.9252 48.5988 23.2244ZM30.5396 30.6463C29.8256 30.9561 29.4352 31.7824 29.6139 32.6054C29.7255 33.1195 31.8808 35.3293 32.4546 35.5181C33.6809 35.9213 34.9324 34.7218 34.5866 33.4743C34.4999 33.1613 34.1549 32.7067 33.4449 31.9701C32.101 30.5761 31.4184 30.265 30.5396 30.6463ZM66.9885 30.7085C66.7626 30.8284 66.121 31.3928 65.5628 31.9627C64.8178 32.7231 64.514 33.1237 64.4209 33.4683C64.0799 34.7304 65.3189 35.9231 66.5504 35.5181C67.1243 35.3293 69.2795 33.1195 69.3911 32.6054C69.7092 31.141 68.2878 30.0189 66.9885 30.7085ZM47.0967 35.3216C41.3704 36.2654 36.6101 40.2874 34.7919 45.7179C34.2316 47.3912 34.0727 48.4927 34.0799 50.6544C34.0855 52.3686 34.1285 52.8219 34.3914 53.9437C35.1309 57.0996 36.9062 60.0982 39.1808 62.0337C41.371 63.8972 41.9918 64.7449 42.175 66.1217L42.2568 66.7354H49.5177H56.7786L56.7825 66.3553C56.788 65.8012 57.1542 64.8311 57.6117 64.1586C57.8313 63.8359 58.5476 63.1295 59.2036 62.589C65.5388 57.3685 66.8246 48.6393 62.2619 41.8255C61.5205 40.7181 59.3333 38.5481 58.2135 37.8086C56.5528 36.7118 54.5851 35.8799 52.6125 35.4402C51.4874 35.1894 48.3127 35.1211 47.0967 35.3216ZM22.8668 48.9296C22.0673 49.3315 21.732 50.595 22.2436 51.278C22.7878 52.0044 22.9657 52.0579 24.8371 52.0579C26.7677 52.0579 27.1349 51.951 27.5688 51.2627C27.8652 50.7924 27.8258 49.8507 27.4905 49.3929C27.0766 48.828 26.676 48.7247 24.8988 48.725C23.5851 48.7251 23.1956 48.7642 22.8668 48.9296ZM72.2108 48.8369C72.0818 48.8904 71.8222 49.0965 71.6339 49.2947C71.1764 49.7767 71.0833 50.7029 71.4363 51.2627C71.8702 51.951 72.2374 52.0579 74.168 52.0579C76.0449 52.0579 76.2163 52.0057 76.7707 51.2656C77.0751 50.8593 77.0766 50.0514 76.774 49.5291C76.3797 48.8488 75.9594 48.7241 74.0885 48.7323C73.1849 48.7363 72.3399 48.7833 72.2108 48.8369ZM42.2834 70.2732C42.548 72.6912 43.6316 74.5531 45.4908 75.785C48.3833 77.7012 52.1544 77.3196 54.6216 74.8608C55.8557 73.6309 56.5049 72.2001 56.7295 70.2148L56.8056 69.5423H49.5045H42.2035L42.2834 70.2732Z",
    stroke: "url(#paint2_linear_1219_139)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1219_139)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4025 44.9781C46.5572 47.8225 45.0271 50.2398 45.0023 50.3498C44.9649 50.5149 45.3761 50.5499 47.3532 50.5499C49.5709 50.5499 49.7437 50.5686 49.6738 50.8011C49.5634 51.1676 48.053 58.7331 48.053 58.9195C48.053 59.0188 48.1014 59.0267 48.1839 58.9407C48.5455 58.5639 55.0427 48.181 54.9998 48.0485C54.9675 47.9484 54.102 47.8804 52.5416 47.8548C50.3362 47.8188 50.1393 47.7947 50.2049 47.5677C50.4627 46.6758 51.8373 40.164 51.8017 40.0038C51.7775 39.8953 50.2478 42.1337 48.4025 44.9781Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1219_139",
    x: 19.85,
    y: 20.85,
    width: 59.3,
    height: 58.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1219_139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1219_139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1219_139",
    x: 43.1,
    y: 38.1,
    width: 13.8,
    height: 22.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1219_139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1219_139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1219_139",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1219_139",
    x1: 27.8856,
    y1: 27.9821,
    x2: 86.7854,
    y2: 59.0445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1219_139",
    x1: 54.0833,
    y1: 32,
    x2: 74.0769,
    y2: 79.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.866900e702668026588ce7378f1013b4.svg";
export { ForwardRef as ReactComponent };